import React from "react";
import styles from "./SubHeadingComponent.module.css";

const SubHeadingComponent = (props) => {
  return (
    <span
      id={props?.id}
      {...props}
      ref={props?.ref}
      className={`${styles.text} ${props?.className}`}
      onClick={props.onClick}
      style={{
        color: props?.color ? props?.color : "var(--black-color)",
        fontFamily: props?.fontFamily ? props?.fontFamily : "Poppins-semibold",
        fontSize: props?.fontSize ? props?.fontSize : " var(--sub_heading)",
      }}
    >
      {props.text}
      {props.children}
    </span>
  );
};

export default SubHeadingComponent;
